import instance from "../../utils/axios";

// 🔹 Save Program
export const saveProgram = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/program/save", formData);
  return response.data; // must include { type, data, message }
};

// 🔹 Update Program
export const updateProgram = async (apiPayloadRequest) => {
  const formData = new URLSearchParams();
  Object.entries(apiPayloadRequest || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/program/update", formData);
  return response.data;
};

// 🔹 Delete Program
export const deleteProgram = async ({ _id, programObjId }) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);
  formData.append("programObjId", programObjId);

  const response = await instance.post("/churches/program/delete", formData);
  return response.data;
};
